import { render, staticRenderFns } from "./modalEdit.vue?vue&type=template&id=3f28d4d0&"
import script from "./modalEdit.vue?vue&type=script&lang=js&"
export * from "./modalEdit.vue?vue&type=script&lang=js&"
import style0 from "./modalEdit.vue?vue&type=style&index=0&id=3f28d4d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports